import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCTA } from './SectionCTA';
import { planningQuestions } from '../data/content';
export function ProblemIntro() {
  return <section className="w-full bg-brand-50 px-5 py-16 md:py-24" data-id="element-255" data-mp="3byyey7asoai7">
      <div className="mx-auto max-w-3xl" data-id="element-256" data-mp="3gvf5171k0yxx">
        <SectionHeading eyebrow="A More Structured Approach to Pediatric Sensory Intervention" title="Understanding Sensory Modulation Is One Thing. Knowing How to Organize an Intervention Plan Is Another." data-id="element-257" data-mp="3gyb08nm0p9io" />

        <div className="mt-10 space-y-4 text-lg leading-relaxed text-brand-900/85" data-id="element-258" data-mp="3uwj4zhpapf4e">
          <p data-id="element-259" data-mp="3poqoi5kye5d">If you're a Pediatric Occupational Therapist, you probably recognize this situation.</p>
          <p data-id="element-260" data-mp="rf98gxpzz5d2">
            You've completed your observations. You've gathered information from parents, caregivers, teachers, and
            clinical sessions. You've identified sensory-related concerns that may be affecting a child's participation
            in everyday activities.
          </p>
          <p data-id="element-261" data-mp="bywvzh77rnk3">But now comes another important question:</p>
        </div>

        <blockquote className="my-8 rounded-3xl bg-brand-700 px-6 py-7 text-center text-2xl font-extrabold leading-snug text-white sm:text-3xl" data-id="element-262" data-mp="bwslgget7qau">
          “How do I turn everything I've learned into a structured intervention plan?”
        </blockquote>

        <div className="space-y-4 text-lg leading-relaxed text-brand-900/85" data-id="element-263" data-mp="znok9xhonlrl">
          <p data-id="element-264" data-mp="upmzn84lzee0">
            You might know several sensory regulation strategies. You may have studied sensory integration principles,
            reviewed professional resources, and explored different intervention approaches.
          </p>
          <p data-id="element-265" data-mp="14ovpppwcs8v3">Yet translating that knowledge into a practical, individualized plan can still feel overwhelming.</p>
        </div>

        <ul className="mt-8 space-y-3" data-id="element-266" data-mp="3bg4qfqwv71vm">
          {planningQuestions.map(q => <li key={q} className="flex items-start gap-3 rounded-2xl bg-white p-4 shadow-sm ring-1 ring-brand-100" data-id="element-267" data-mp="36gs37522zssi">
              <HelpCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-brand-600" aria-hidden="true" data-id="element-268" data-mp="1lqj6zqawb" />
              <span className="text-base font-semibold text-brand-950 sm:text-lg" data-id="element-269" data-mp="413mx5kgwx0x">{q}</span>
            </li>)}
        </ul>

        <div className="mt-10 space-y-4 text-lg leading-relaxed text-brand-900/85" data-id="element-270" data-mp="dxzpkunoqoxk">
          <p data-id="element-271" data-mp="iwszye7odzti">
            These are the questions the <strong className="text-brand-800" data-id="element-272" data-mp="ivrmk336t18m">Sensory Modulation Treatment Roadmap™</strong>{' '}
            is designed to help you explore.
          </p>
          <p data-id="element-273" data-mp="rp4ti8y363dp">
            Not another enormous collection of disconnected sensory activities. Not a list of techniques that encourages
            you to apply the same strategy to every child.
          </p>
          <p data-id="element-274" data-mp="11nkia59n50k1">
            Instead, a structured planning framework that helps you connect assessment findings, functional priorities,
            intervention options, and progress monitoring.
          </p>
          <p className="rounded-2xl border-l-4 border-mint-500 bg-white p-5 font-bold text-brand-950" data-id="element-275" data-mp="2r4g2u0m4jgbr">
            Because effective clinical planning requires more than knowing what activities exist. It requires
            understanding why, when, and for whom an intervention may be appropriate.
          </p>
        </div>

        <SectionCTA label="Show Me the Complete Roadmap™" data-id="element-276" data-mp="2c8gls0h1e5uh" />
      </div>
    </section>;
}